<template>
    <div class="airdrop-season-notification"
         :class="{'airdrop-season-notification--under-dashboard': isMovedDown}"
         v-html="marketingStore.headerLink"/><!-- eslint-disable-line vue/no-v-html -->
</template>

<script setup lang="ts">
    import { useMarketingStore } from '@/js/store/quests/dashboard/MarketingStore';

    defineProps<{ isMovedDown: boolean}>();

    const marketingStore = useMarketingStore();
</script>

<style scoped lang="scss">
@use "@/sass/partials/variables" as legacyVariables;
@use "@/sass/design-system/variables" as variables;
@use "@/sass/partials/breakpoints" as breakpoints;

.airdrop-season-notification {
    padding: 7px;
    background: legacyVariables.$menu-gradient-alternative;
    color: variables.$baseBlack;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.2;
    text-align: center;

    &--under-dashboard {
        margin-top: legacyVariables.$dashboard-bar-height;
    }

    :deep(a) {
        color: #2f00b2;
        font-weight: 700;
        text-decoration: underline;
        text-transform: uppercase;

        &:hover {
            text-decoration: none;
        }
    }

    @media ((min-width: breakpoints.$md-breakpoint) and (max-width: breakpoints.$lg-breakpoint-max-width)) {
        padding-left: 30px;
    }
}
</style>
